import "./footer.css";
import { useTranslation } from "react-i18next";

export default function Footer() {
	const { t } = useTranslation();
	const currentYear = new Date().getFullYear();

	return (
		<footer className="footer">
			<div className="footerContent">
				<p>
					&copy; {currentYear} {t("footer.text")} | {t("footer.rights")}
				</p>
				<p className="footerCredit">
					{t("footer.madeBy")}{" "}
					<a
						href="https://instant-solutions.eu/"
						target="_blank"
						rel="noopener"
					>
						Инстант Сълюшънс
					</a>
				</p>
			</div>
		</footer>
	);
}
